

<img  *ngIf="visible && value"
[height]="height" [width]="width"
[src]="value" 
>
 